export const LOCATIONS = [
  { name: "London", value: "London,GB" },
  { name: "Birmingham", value: "Birmingham,GB" },
  { name: "Manchester", value: "Manchester,GB" }
];
export const APP_ID = "afebe26ca128f00237c10ba312eba8b7";
export const WEATHER_ENDPOINT =
  "https://api.openweathermap.org/data/2.5/weather?q=";
